import {NgModule} from "@angular/core";
import {AvatarComponent} from "./avatar/avatar.component";
import {CarComponent} from "./car/car.component";
import {InputBoolComponent} from "./input-bool/input-bool.component";
import {ItemComponent} from "./item/item.component";
import {MapPopupComponent} from "./map-popup/map-popup.component";
import {MapPopupPoiComponent} from "./map-popup-poi/map-popup-poi.component";
import {OutputComponent} from "./output/output.component";
import {PageTitleComponent} from "./page-title/page-title.component";
import {PoiComponent} from "./poi/poi.component";
import {SelectComponent} from "./select/select.component";
import {SelectChipComponent} from "./select-chip/select-chip.component";
import {PopoverFlagComponent} from "./popover-flag/popover-flag.component";
import {PopoverMapSettingsComponent} from "./popover-map-settings/popover-map-settings.component";
import {PopoverMapTypeComponent} from "./popover-map-type/popover-map-type.component";
import {PopoverSelectComponent} from "./popover-select/popover-select.component";
import {PopoverSelectPoiComponent} from "./popover-select-poi/popover-select-poi.component";
import {SelectPoiComponent} from "./select-poi/select-poi.component";
import {SelectDialCodeComponent} from "./select-dial-code/select-dial-code.component";
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {TranslateModule} from "@ngx-translate/core";
import {CommonComponentsModule} from "../common/common-components.module";
import {CommonPipesModule} from "../../pipes/common/pipes.module";
import {UserPersonalDataComponent} from "src/app/components/mobile/user-personal-data/user-personal-data.component";
import {ShippingDataComponent} from "src/app/components/mobile/shipping-data/shipping-data.component";
import {ReactiveFormsModule} from "@angular/forms";
import {DemoChatMobileComponent} from "./demo-chat/demo-chat.component";
import {DemoBenvenutoComponent} from "./demo-benvenuto/demo-benvenuto.component";
import {DemoSpiegazioneComponent} from "./demo-spiegazione/demo-spiegazione.component";

@NgModule({
  declarations: [
    DemoChatMobileComponent,
    DemoBenvenutoComponent,
    DemoSpiegazioneComponent,
    AvatarComponent,
    CarComponent,
    InputBoolComponent,
    ItemComponent,
    MapPopupComponent,
    MapPopupPoiComponent,
    OutputComponent,
    PageTitleComponent,
    PoiComponent,
    SelectComponent,
    SelectChipComponent,
    PopoverFlagComponent,
    PopoverMapSettingsComponent,
    PopoverMapTypeComponent,
    PopoverSelectComponent,
    PopoverSelectPoiComponent,
    SelectPoiComponent,
    SelectDialCodeComponent,
    UserPersonalDataComponent,
    ShippingDataComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TranslateModule,
    CommonComponentsModule,
    CommonPipesModule,
    ReactiveFormsModule
  ],
  exports: [
    DemoChatMobileComponent,
    DemoBenvenutoComponent,
    DemoSpiegazioneComponent,
    AvatarComponent,
    CarComponent,
    InputBoolComponent,
    ItemComponent,
    MapPopupComponent,
    MapPopupPoiComponent,
    OutputComponent,
    PageTitleComponent,
    PoiComponent,
    SelectComponent,
    SelectChipComponent,
    UserPersonalDataComponent,
    ShippingDataComponent,
    PopoverFlagComponent,
    PopoverMapSettingsComponent,
    PopoverMapTypeComponent,
    PopoverSelectComponent,
    PopoverSelectPoiComponent,
    SelectPoiComponent,
    SelectDialCodeComponent
  ],
})

export class MobileComponentsModule {}
